import Vue from 'vue';

export default {
    enviar(idCheckListItem, imagens, onUploadProgress) {
        const formData = new FormData();
        imagens.forEach(imagem => formData.append('imagens', imagem));
        return Vue.prototype.$http.post(`/checklist/item/${idCheckListItem}/anexos`, formData, { onUploadProgress });
    },

    carregar(idCheckListItem, idAnexo) {
        return Vue.prototype.$http.get(`/checklist/item/${idCheckListItem}/anexos/${idAnexo}`, {
            responseType: 'blob'
        });
    },

    excluir(idCheckListItem, idAnexo) {
        return Vue.prototype.$http.delete(`/checklist/item/${idCheckListItem}/anexos/${idAnexo}`);
    }
};
